export default __webpack_public_path__ + "static/media/wrong.c730ec19.svg";